const Y2=()=>{

    return <>这是样式2</>
}

export default Y2;